import { render, staticRenderFns } from "./xmasBannerSubscription.vue?vue&type=template&id=21ee653a&scoped=true"
import script from "./xmasBannerSubscription.vue?vue&type=script&lang=js"
export * from "./xmasBannerSubscription.vue?vue&type=script&lang=js"
import style0 from "./xmasBannerSubscription.vue?vue&type=style&index=0&id=21ee653a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ee653a",
  null
  
)

export default component.exports